import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  const navLinks = [
    { to: '/', label: '首页' },
    { to: '/category/全部', label: '分类' },
    { to: '/about', label: '关于我们' },
  ];

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  return (
    <header className="sticky top-0 z-50 bg-background-50/95 backdrop-blur-sm border-b border-background-200">
      <nav className="max-w-7xl mx-auto px-4 md:px-6" aria-label="主导航">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer" aria-label="八仔漫画网首页">
            <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
              <i className="ri-book-open-line text-background-50 text-xl"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-900 hidden sm:block">
              八仔漫画网
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.to}
                to={link.to}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  isActive(link.to)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            {searchOpen ? (
              <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2 border border-background-200">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="搜索漫画..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-900 w-40 placeholder:text-foreground-400"
                  autoFocus
                  onKeyDown={(e) => {
                    if (e.key === 'Escape') {
                      setSearchOpen(false);
                      setSearchQuery('');
                    }
                  }}
                />
                <button
                  onClick={() => { setSearchOpen(false); setSearchQuery(''); }}
                  className="text-foreground-400 hover:text-foreground-700 cursor-pointer"
                  aria-label="关闭搜索"
                >
                  <i className="ri-close-line"></i>
                </button>
              </div>
            ) : (
              <button
                onClick={() => setSearchOpen(true)}
                className="w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-200 text-foreground-600 transition-colors cursor-pointer"
                aria-label="打开搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
            )}
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-9 h-9 flex items-center justify-center rounded-full hover:bg-background-200 text-foreground-700 cursor-pointer"
            aria-label="打开菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden border-t border-background-200 py-3 animate-in">
            <div className="flex flex-col gap-1">
              {navLinks.map((link) => (
                <Link
                  key={link.to}
                  to={link.to}
                  onClick={() => setMobileOpen(false)}
                  className={`px-4 py-2.5 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                    isActive(link.to)
                      ? 'bg-primary-100 text-primary-700'
                      : 'text-foreground-700 hover:bg-background-200'
                  }`}
                >
                  {link.label}
                </Link>
              ))}
            </div>
            <div className="mt-2 px-4">
              <div className="flex items-center gap-2 bg-background-100 rounded-full px-4 py-2.5 border border-background-200">
                <i className="ri-search-line text-foreground-500 text-sm"></i>
                <input
                  type="text"
                  placeholder="搜索漫画..."
                  className="bg-transparent border-none outline-none text-sm text-foreground-900 w-full placeholder:text-foreground-400"
                />
              </div>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}